const strIsHTML = (str) => {
  const document = new DOMParser().parseFromString(str, "text/html");

  return Array.from(document.body.childNodes).some(
    (node) => node.nodeType === 1
  );
};

export default strIsHTML;
